export default class CreateComponentForm {
  public name: string = '';
  public status: string = '';
}

